import { DataTypeEnum } from "../../api/types/field-type";

const choiceReferenceTypes = new Set([
  "MULTIPLE_CHOICE",
  "MULTIPLE_CHOICE_OPTION",
  "CHECKBOX",
]);

const multiChoiceReferenceTypes = new Set([
  "CHECKBOXES",
  "MULTI_SELECT",
  "MULTI_SELECT_OPTION",
]);

const textTypes = new Set([
  "EMAIL",
  "PHONE",
  "INPUT_EMAIL",
  "INPUT_PHONE_NUMBER",
  "INPUT_LINK",
]);

const numericTypes = new Set([
  "NUMBER",
  "RATING",
  "INPUT_NUMBER",
  "RANKING_OPTION",
]);

const dateTypes = new Set(["DATE", "INPUT_DATE"]);

const dropdownTypes = new Set([
  "DROPDOWN",
  "INPUT_TIME",
  "TIME",
  "DROPDOWN_OPTION",
]);

export const isTallyMappingCompatible = (
  questionType: string,
  dataType: string,
): boolean => {
  if (choiceReferenceTypes.has(questionType)) {
    return [
      DataTypeEnum.List,
      DataTypeEnum.Reference,
      DataTypeEnum.Boolean,
    ].includes(dataType as DataTypeEnum);
  }

  if (multiChoiceReferenceTypes.has(questionType)) {
    return [DataTypeEnum.List, DataTypeEnum.Reference].includes(
      dataType as DataTypeEnum,
    );
  }

  if (questionType === "INPUT_TEXT") {
    return [
      DataTypeEnum.String,
      DataTypeEnum.Text,
      DataTypeEnum.Group,
      DataTypeEnum.List,
      DataTypeEnum.Boolean,
    ].includes(dataType as DataTypeEnum);
  }

  if (textTypes.has(questionType)) {
    return [
      DataTypeEnum.String,
      DataTypeEnum.Text,
      DataTypeEnum.Group,
    ].includes(dataType as DataTypeEnum);
  }

  if (questionType === "TEXTAREA") {
    return dataType === DataTypeEnum.Text;
  }

  if (numericTypes.has(questionType)) {
    return [DataTypeEnum.Number, DataTypeEnum.NumberWithDecimals].includes(
      dataType as DataTypeEnum,
    );
  }

  if (dateTypes.has(questionType)) {
    return dataType === DataTypeEnum.Date;
  }

  if (dropdownTypes.has(questionType)) {
    return [
      DataTypeEnum.String,
      DataTypeEnum.Reference,
      DataTypeEnum.List,
      DataTypeEnum.Boolean,
    ].includes(dataType as DataTypeEnum);
  }

  if (questionType === "FILE_UPLOAD") {
    return [DataTypeEnum.Video, DataTypeEnum.Image].includes(
      dataType as DataTypeEnum,
    );
  }

  return false;
};
